import { Id, LaravelResponse, UserOptionResource, keyToUrl } from "@dgs/core";
import axios from "axios";
import { Interval, format } from "date-fns";
import { EventParticipationStatus } from "../../types/event";
import { EventTypeOptionResource } from "../../types/eventType";
import { LocationIndexResource } from "../../types/location";

export interface EventCalendarResource {
	id: Id;
	name: string;
	start: string;
	timezone: string;
	end: string;
	createdByUser: UserOptionResource;
	isHighlight: boolean;
	eventType: EventTypeOptionResource;
	location: LocationIndexResource | null;
	participationStatus: EventParticipationStatus;
	rating: number | null;
}

const calendarKey = ["events", "calendar"];

export const calendarEventService = {
	calendarKey,
	calendar: (dateRange: Interval, filterId: Id | null, showOnlyOwnEvents: boolean) =>
		axios.post<LaravelResponse<EventCalendarResource[]>>(keyToUrl(calendarKey), {
			...dateRange,
			start: format(dateRange.start, "yyyy-MM-dd"),
			end: format(dateRange.end, "yyyy-MM-dd"),
			filterId,
			showOnlyOwnEvents: showOnlyOwnEvents ? "1" : "0",
		}),
};
